import { FC } from 'react';
import { SplunkCedantTracker } from '@resolutionlife/ui';
import { Outlet } from 'react-router-dom';

import { AppConfigProvider } from '../context/app-config-context/app-config-context';
import { PiiReportProvider } from '../context/pii-report-context';
import { DefaultLayout } from './default';

export const AuthenticatedLayout: FC = () => {
  return (
    <AppConfigProvider>
      <PiiReportProvider>
        <SplunkCedantTracker />
        <DefaultLayout>
          <Outlet />
        </DefaultLayout>
      </PiiReportProvider>
    </AppConfigProvider>
  );
};
